import React, { useContext } from "react";
import '../../../css/frontPage.css';
import Icon from "../../../assets/icons/icon";
import { AgentContext } from "../../../context/AgentContext";

function List({filter, getMyFilter, index}) {
    const {isB2B} = useContext(AgentContext)

    return (
        <div className="quilityListWrapper" key={`filterOption${index}`}>
            <div className="quilityListType" style={{flex: '2'}}>{filter.type}</div>
            <div className="quilityListTitle" style={{flex: '2'}}>{filter.name}</div>
            <div className="listButtonHolder" style={{marginTop: '5px',marginLeft: '-5px'}}>
                <div className={`${isB2B ? 'b2b ' : ''}listIcon selectedIcon`} onClick={()=>getMyFilter(filter.params,true,filter.name, filter)}><Icon name='q-phone-call-outgoing'  height='34' adjustSize='15'/></div>
                <div className={`${isB2B ? 'b2b ' : ''}listIcon`} onClick={()=>getMyFilter(filter.params,false,filter.name, filter)}><Icon name='expand-q' adjustSize='15' height='34'/></div>
            </div>
        </div>
    );
}

export default List;
